/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  LoadingOutlined,
  WhatsAppOutlined
} from "@ant-design/icons";
import { GridContent, PageContainer } from "@ant-design/pro-components";
import {
  Card,
  Carousel,
  Col,
  Empty,
  Flex,
  FloatButton,
  Image,
  List,
  message,
  Modal,
  Pagination,
  Row,
  Spin
} from "antd";
import Meta from "antd/es/card/Meta";
import { Footer, Header } from "antd/es/layout/layout";
import axios from "axios";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getSocket2 } from "../service/socket.service";
// import dayjs from "dayjs";
// const currentDate = dayjs().format("YYYY-MM-DD");
const privateKey =
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const BASE = privateKey.length;
const SECRET = 987654321;

const FBLiveProductListingPage = () => {
  const authorization_token = btoa(`chgold_admin:chgold_password`);
  const new_token = btoa(
    `d77d00700bc79392f68fa1b7a7705af65220710e20a45722511f6dc0c2683917:${authorization_token}`
  );

  const { id } = useParams();
  const hasInitialized = useRef(false);
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [liveData, setLiveData] = useState(null);
  // const [api, contextHolder] = notification.useNotification();
  // const [fileList, setFileList] = useState([]);
  // const [ImgModalOpen, isImgModalOpen] = useState(false);
  // const [eventValid, isEventValid] = useState(false);
  const [customerNameListModalOpen, isCustomerNameListModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const startIndex = (currentPage - 1) * pageSize;

  const currentData = useMemo(() => {
    return dataList.slice(startIndex, startIndex + pageSize);
  }, [dataList, pageSize, startIndex]);

  let contacts = [
    { name: "❤️ 011-57677594 - Austin Crest", ws_name: "Austin Crest", phone: "601157677594" },
    { name: "💜 010-3057556 - Taiping", ws_name: "Taiping", phone: "60103057556" },
    { name: "💚 011-57669891 - Sungai Petani", ws_name: "Sungai Petani", phone: "601157669891" },
    { name: "🧡 011-13155973 - Kajang", ws_name: "Kajang", phone: "601113155973" },
    { name: "💛 012-5878136 - Gunung Rapat", ws_name: "Gunung Rapat", phone: "60125878136" },
  ];

  for (let i = contacts.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [contacts[i], contacts[j]] = [
      contacts[j],
      contacts[i],
    ];
  }

  // // Wrap notification function
  // const openNotification = useCallback(
  //   (title, description) => {
  //     api.open({
  //       message: title,
  //       description,
  //       placement: "topRight",
  //       showProgress: true,
  //       pauseOnHover: true,
  //     });
  //   },
  //   [api]
  // );

  function decodeBase62(str) {
    return str
      .split("")
      .reduce((acc, c) => acc * BASE + privateKey.indexOf(c), 0);
  }

  const decodeId = useCallback((token) => {
    const num = decodeBase62(token.replace(/^0+/, "")); // remove leading zeros
    const id = num ^ SECRET;
    return id;
  }, []);

  // const decryptParams = decodeId(id);

  const fetchProductListing = useCallback(async () => {
    try {
      const { data: responseData } = await axios.get(
        `${process.env.REACT_APP_ENVIRONMENT === "PRODUCTION"
          ? process.env.REACT_APP_API_BASE_URL
          : process.env.REACT_APP_API_STAGING_BASE_URL
        }/fbLive/getLiveProductListingByLiveId/${id}`,
        {
          headers: {
            Authorization: `Basic ${new_token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!responseData.status) {
        message.error(responseData.message);
        return responseData.status;
      }

      const liveData = responseData.liveResult;
      const productList = responseData.data;

      // if (
      //   currentDate >= liveData.startDate &&
      //   currentDate <= liveData.endDate
      // ) {
      //   isEventValid(true);
      // }

      if (productList.length > 0) {
        for (const pl of productList) {
          let tmpCustomerNameList = [];

          if (pl.customerNameList) {
            try {
              tmpCustomerNameList = JSON.parse(pl.customerNameList);
            } catch (error) {
              tmpCustomerNameList = [];
            }
          }

          pl.customerNameList = tmpCustomerNameList;
        }
      }

      setLiveData(liveData);
      setDataList(productList);
      return responseData.status;
    } catch (error) {
      console.log("Error: ", error);
    }
  }, [id, new_token]);

  const componentInit = useCallback(async () => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    if (!id) {
      return;
    }

    try {
      const result = await fetchProductListing();
      if (!result) {
        return;
      }

      setIsContentLoaded(true);
    } catch (error) {
      console.log("Initialization error:", error);
      message.error("Page failed to initialize");
    }
  }, [id, fetchProductListing]);

  useEffect(() => {
    componentInit();
  }, [componentInit, dataList, decodeId, id]);

  // useEffect(() => {
  //   const socket = getSocket2();

  //   // socket.on("productUpdate", (data) => {
  //   //   if (data?.data) {
  //   //     const updatedData = data.data;
  //   //     setDataList((prev) => {
  //   //       const index = prev.findIndex((item) => item.id === updatedData.id);

  //   //       if (index !== -1) {
  //   //         const updatedList = [...prev];
  //   //         updatedList[index] = {
  //   //           ...updatedList[index],
  //   //           ...updatedData,
  //   //           image: updatedData.image ?? [],
  //   //         };
  //   //         return updatedList;
  //   //       } else {
  //   //         return [...prev, updatedData];
  //   //       }
  //   //     });
  //   //   }
  //   // });

  //   // socket.on("productChanged", (data) => {
  //   //   if (data?.data?.length > 0) {
  //   //     const tmpData = dataList;
  //   //     const merged = tmpData.map((item1) => {
  //   //       const match = data.data.find((item2) => item2.id === item1.id);
  //   //       return match
  //   //         ? {
  //   //             ...item1,
  //   //             name: match.name,
  //   //             label: match.label,
  //   //             liveItemCode: match.liveItemCode,
  //   //             designCode: match.designCode,
  //   //             // quantity: match.quantity,
  //   //             labourFee: match.labourFee,
  //   //             price: match.price,
  //   //             remark: match.remark,
  //   //             fbLiveProductVariations: match.fbLiveProductVariations,
  //   //           }
  //   //         : item1;
  //   //     });

  //   //     setDataList(merged);
  //   //   }

  //   //   // const title = "📦 New order";
  //   //   // console.log("New ORDER");
  //   //   // openNotification(title, data);
  //   // });

  //   // socket.on("productsUpdate", (data) => {
  //   //   if (data?.data) {
  //   //     const updatedData = data.data;
  //   //     if (updatedData.length > 0) {
  //   //       for (const ud of updatedData) {
  //   //         let tmpCustomerNameList = [];

  //   //         if (ud.customerNameList) {
  //   //           try {
  //   //             tmpCustomerNameList = JSON.parse(ud.customerNameList);
  //   //           } catch (error) {
  //   //             tmpCustomerNameList = [];
  //   //           }
  //   //         }

  //   //         ud.customerNameList = tmpCustomerNameList;
  //   //       }
  //   //     }
  //   //     setDataList(updatedData);
  //   //   }
  //   //   // if (data?.liveData) {
  //   //   //   setLiveData(data.liveData);
  //   //   //   if (
  //   //   //     currentDate < liveData.startDate &&
  //   //   //     currentDate > liveData.endDate
  //   //   //   ) {
  //   //   //     isEventValid(true);
  //   //   //   }
  //   //   // }
  //   // });

  //   socket.on("updateFbLive", (data) => {
  //     if (!data) return;
  //     setLiveData((prev) => ({
  //       ...prev,
  //       ...data,
  //     }));
  //   });

  //   socket.on("createProduct", (data) => {
  //     if (!data) return;

  //     if (data?.catalogHide === 0) {
  //       let tmpArr = [...dataList, data];

  //       tmpArr.sort(
  //         (a, b) =>
  //           new Date(b.catalogShowDatetime) -
  //           new Date(a.catalogShowDatetime)
  //       );

  //       setDataList(tmpArr);
  //     }
  //   });

  //   socket.on("updateProduct", (data) => {
  //     if (!data) return;
  //     if (data?.catalogHide === 0) {
  //       let tmpDataList = dataList;

  //       const index = tmpDataList.findIndex((td) => td.id === data.id);

  //       if (index !== -1) {
  //         tmpDataList[index] = data;
  //       } else {
  //         tmpDataList.push(data);
  //       }

  //       tmpDataList.sort(
  //         (a, b) =>
  //           new Date(b.catalogShowDatetime) -
  //           new Date(a.catalogShowDatetime)
  //       );

  //       console.log(tmpDataList, "tmpDataList");

  //       setDataList(tmpDataList);
  //     }
  //   });

  //   socket.on("hideProduct", (data) => {
  //     if (!data) return;

  //     if (data.catalogHide === 0) {
  //       setDataList((prev) => {
  //         const tmpArr = [...prev];

  //         const index = tmpArr.findIndex(
  //           (item) => item.id === data.id
  //         );

  //         if (index !== -1) {
  //           tmpArr[index] = {
  //             ...tmpArr[index],
  //             ...data,
  //           };
  //         } else {
  //           tmpArr.push(data);
  //         }

  //         tmpArr.sort(
  //           (a, b) =>
  //             new Date(b.catalogShowDatetime) -
  //             new Date(a.catalogShowDatetime)
  //         );

  //         return tmpArr;
  //       });
  //     } else {
  //       setDataList((prev) =>
  //         prev.filter((item) => item.id !== data.id)
  //       );
  //     }
  //   });

  //   socket.on("deleteProduct", (id) => {
  //     if (!id) return;

  //     setDataList((prev) =>
  //       prev.filter((item) => item.id !== Number(id))
  //     );
  //   });

  //   socket.on("updateProductVariation", (data) => {
  //     if (!data) return;
  //     const tmpId = Number(data.fbLiveProductId);
  //     setDataList((prevDataList) =>
  //       prevDataList.map((item) =>
  //         item.id === tmpId
  //           ? { ...item, fbLiveProductVariations: data.fbLiveProductVariations }
  //           : item
  //       )
  //     );
  //   });

  //   return () => {
  //     // socket.off("productUpdate");
  //     // socket.off("productsUpdate");
  //     socket.off("updateFbLive");
  //     socket.off("createProduct");
  //     socket.off("updateProduct");
  //     socket.off("deleteProduct");
  //     socket.off("updateProductVariation");
  //     socket.off("hideProduct");
  //     // socket.off("productChanged");
  //   };
  // }, [dataList]);

  useEffect(() => {
    const socket = getSocket2();

    const sortProducts = (list) => {
      return [...list].sort(
        (a, b) =>
          new Date(b.catalogShowDatetime) -
          new Date(a.catalogShowDatetime)
      );
    };

    // =========================
    // UPDATE FB LIVE
    // =========================
    const handleUpdateFbLive = (data) => {
      if (!data) return;

      // console.log("updateFbLive received:", data);

      setLiveData((prev) => ({
        ...prev,
        ...data,
      }));
    };

    // =========================
    // CREATE PRODUCT
    // =========================
    const handleCreateProduct = (data) => {
      if (!data) return;

      // console.log("createProduct received:", data);

      if (data.catalogHide !== 0) return;

      setDataList((prev) => {
        // prevent duplicate
        const exists = prev.some(
          (item) => item.id === data.id
        );

        if (exists) {
          return prev;
        }

        return sortProducts([
          ...prev,
          data,
        ]);
      });
    };

    // =========================
    // UPDATE PRODUCT
    // =========================
    const handleUpdateProduct = (data) => {
      if (!data) return;

      // console.log("updateProduct received:", data);

      setDataList((prev) => {
        // Product is hidden
        if (data.catalogHide !== 0) {
          return prev.filter(
            (item) => item.id !== data.id
          );
        }

        const index = prev.findIndex(
          (item) => item.id === data.id
        );

        // Existing product
        if (index !== -1) {
          const updatedList = [...prev];

          updatedList[index] = {
            ...updatedList[index],
            ...data,
          };

          return sortProducts(updatedList);
        }

        // Product doesn't exist yet
        return sortProducts([
          ...prev,
          data,
        ]);
      });
    };

    // =========================
    // HIDE PRODUCT
    // =========================
    const handleHideProduct = (data) => {
      if (!data) return;

      // console.log("hideProduct received:", data);

      setDataList((prev) => {
        // Hide from listing
        if (data.catalogHide !== 0) {
          return prev.filter(
            (item) => item.id !== data.id
          );
        }

        // Unhide / show again
        const index = prev.findIndex(
          (item) => item.id === data.id
        );

        if (index !== -1) {
          const updatedList = [...prev];

          updatedList[index] = {
            ...updatedList[index],
            ...data,
          };

          return sortProducts(updatedList);
        }

        return sortProducts([
          ...prev,
          data,
        ]);
      });
    };

    // =========================
    // DELETE PRODUCT
    // =========================
    const handleDeleteProduct = (id) => {
      if (!id) return;

      // console.log("deleteProduct received:", id);

      setDataList((prev) =>
        prev.filter(
          (item) => item.id !== Number(id)
        )
      );
    };

    // =========================
    // UPDATE VARIATION
    // =========================
    const handleUpdateProductVariation = (data) => {
      if (!data) return;

      // console.log(
      //   "updateProductVariation received:",
      //   data
      // );

      const productId = Number(data.fbLiveProductId);

      setDataList((prev) =>
        prev.map((item) =>
          item.id === productId
            ? {
              ...item,
              fbLiveProductVariations:
                data.fbLiveProductVariations,
            }
            : item
        )
      );
    };

    socket.on(
      "updateFbLive",
      handleUpdateFbLive
    );

    socket.on(
      "createProduct",
      handleCreateProduct
    );

    socket.on(
      "updateProduct",
      handleUpdateProduct
    );

    socket.on(
      "hideProduct",
      handleHideProduct
    );

    socket.on(
      "deleteProduct",
      handleDeleteProduct
    );

    socket.on(
      "updateProductVariation",
      handleUpdateProductVariation
    );

    return () => {
      socket.off(
        "updateFbLive",
        handleUpdateFbLive
      );

      socket.off(
        "createProduct",
        handleCreateProduct
      );

      socket.off(
        "updateProduct",
        handleUpdateProduct
      );

      socket.off(
        "hideProduct",
        handleHideProduct
      );

      socket.off(
        "deleteProduct",
        handleDeleteProduct
      );

      socket.off(
        "updateProductVariation",
        handleUpdateProductVariation
      );
    };
  }, []);

  const viewCustomerNameListOnClick = useCallback((id) => {
    setSelectedId(null);
    setSelectedId(id);
    isCustomerNameListModalOpen(true);
  }, [])

  const viewCustomerNameListModal = useMemo(
    () => {
      const tmpData = dataList.find((fl) => fl.id === selectedId);

      return (
        <Modal
          title="Name List"
          open={customerNameListModalOpen}
          onCancel={() => isCustomerNameListModalOpen(false)}
          footer={null}
          width={480}
        >
          {tmpData && tmpData?.customerNameList && tmpData?.customerNameList.length > 0 ? (
            <List
              bordered
              dataSource={tmpData.customerNameList}
              renderItem={(item, index) => (
                <List.Item>
                  <span strong>{index + 1}.</span> &nbsp;
                  {item}
                </List.Item>
              )}
            />
          ) : (
            <p type="secondary">No customer names found.</p>
          )}
        </Modal>
      )
    },
    [customerNameListModalOpen, dataList, selectedId]
  );

  // const viewImgModalOpen = (imgArr) => {
  //   if (imgArr) {
  //     setFileList(imgArr);
  //     isImgModalOpen(true);
  //   }
  // };

  // const viewImgModal = useMemo(
  //   () => (
  //     <Modal
  //       title="View Product Image"
  //       open={ImgModalOpen}
  //       okButtonProps={{ style: { display: "none" } }}
  //       onCancel={() => isImgModalOpen(false)}
  //     >
  //       <div
  //         style={{
  //           display: "grid",
  //           gap: "16px",
  //           gridTemplateColumns:
  //             fileList?.length < 2 ? "repeat(1, 1fr)" : "repeat(2, 1fr)",
  //           alignItems: "center",
  //         }}
  //       >
  //         {fileList ? (
  //           fileList.map((i) => (
  //             <Image
  //               src={i.fullImagePath}
  //               onError={(e) => {
  //                 e.target.onerror = null; // prevent infinite loop
  //                 e.target.src = "/noimage.jpg";
  //               }}
  //             />
  //           ))
  //         ) : (
  //           <Empty description="No data available" />
  //         )}
  //       </div>
  //     </Modal>
  //   ),
  //   [ImgModalOpen, fileList]
  // );

  const productDataCardList = useMemo(() => {
    return (
      <>
        {currentData.length > 0 ? (
          <>
            <Row gutter={[18, 18]}>
              {currentData.map((item) => {
                // const totalCount = item.fbLiveProductVariations.length;
                // const soldArr = item.fbLiveProductVariations.filter((i) => i.status === 2 || i.quantity === 0);

                return (
                  <Col
                    key={item.id}
                    xs={12}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={6}
                    style={{ width: "100%", margin: 0 }}
                  >
                    <Card
                      draggable
                      hoverable
                      // onClick={() => viewImgModalOpen(item.fbProductImage)}
                      cover={
                        <>
                          {item.image !== `[]` && item.fbProductImage ? (
                            <div>
                              <Carousel
                                autoplay
                                autoplaySpeed={3000}
                                style={{
                                  maxHeight: 310,
                                  overflow: "hidden",
                                  borderRadius: "8px 8px 0px 0px",
                                }}
                              >
                                {item.fbProductImage.map((img, idx) => (
                                  <div>
                                    <Image
                                      // onClick={() => viewImgModalOpen(item.fbProductImage)}
                                      key={item.id}
                                      alt={item.name}
                                      src={img?.fullImagePath || '/noimage.jpg'}
                                      fallback="/noimage.jpg"
                                      preview={{
                                        src: img?.fullImagePath || '/noimage.jpg',
                                        fallback: '/noimage.jpg',
                                      }}
                                      width={"100%"}
                                      className="imageCont"
                                      style={{
                                        maxHeight: 310,
                                        width: "100%",
                                        display: "block",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                ))}
                              </Carousel>
                            </div>
                          ) : (
                            <Image
                              width={"100%"}
                              alt={item.name}
                              src="/noimage.jpg"
                              style={{
                                maxHeight: 310,
                                width: "100%",
                                display: "block",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </>
                      }
                    >
                      <Meta
                        title={item.name}
                        className="productDesc"
                        description={
                          <>
                            <Flex
                              style={{ flexDirection: "column" }}
                              gap={"small"}
                            >
                              {/* <div
                                    style={{
                                      color: "#333333ff",
                                    }}
                                  >
                                    RM{Number(item.price).toFixed(2)}
                                  </div> */}
                              <div
                                style={{
                                  textAlign: "-webkit-center",
                                }}
                              >
                                {item.fbLiveProductVariations.length === 0 ? "Sold Out" : ""}
                                {/* {totalCount ? totalCount === soldArr.length ? "Sold Out" : soldArr.length === 0 ? '' : `${soldArr.length} Sold` : "Sold Out"} */}
                                {/* {item.fbLiveProductVariations.length <= 5 ? (
                                item.fbLiveProductVariations.length ===
                                  0 ? (
                                  <Tag
                                    color="red"
                                    style={{
                                      marginRight: 0,
                                    }}
                                  >
                                    Out Of Stock
                                  </Tag>
                                ) : (
                                  <Tag
                                    color="orange"
                                    style={{
                                      marginRight: 0,
                                    }}
                                  >
                                    {item.fbLiveProductVariations.length}{" "}
                                    pcs
                                  </Tag>
                                )
                              ) : (
                                <Tag
                                  color="green"
                                  style={{
                                    marginRight: 0,
                                  }}
                                >
                                  {item.fbLiveProductVariations.length} pcs
                                </Tag>
                              )} */}
                              </div>
                              {item.showItemcode === 1 ? (
                                <div>Live Code: {item.liveItemCode}</div>
                              ) : (
                                <div>No Live Code Yet</div>
                              )}
                            </Flex>
                          </>
                        }
                      />
                      {item.customerNameList && item.customerNameList.length > 0 ? <>
                        <div style={{ position: "relative" }}>
                          {/* <Tooltip title="View Name List"> */}
                          <a
                            onClick={() => { viewCustomerNameListOnClick(item.id) }}
                            style={{ textAlign: "center", display: "block", marginTop: "10px" }}>
                            {/* <MoreOutlined /> */}
                            View Name List
                          </a>
                          {/* </Tooltip> */}
                        </div>
                      </> : <>
                      </>}
                    </Card>
                  </Col>
                )
              })}
            </Row>

            <div style={{ textAlign: "center", marginTop: 20 }}>
              {/* <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={dataList.length}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={true}
              /> */}
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={dataList.length}
                onChange={(page, size) => {
                  setCurrentPage(page);
                  setPageSize(size);
                }}
                showSizeChanger={true}
                pageSizeOptions={['10', '20', '50', '100', '500']}
              />
            </div>
          </>
        ) : (
          <Row gutter={[18, 18]}>
            <Empty
              // imageStyle={{ width: 300, height: 150 }}
              style={{
                marginInline: "auto",
                marginBlock: 100,
                fontSize: "20px",
              }}
              className="specialFontFamily"
              description="Empty Product"
            />
          </Row>
        )}
      </>
    )
  }, [currentData, currentPage, dataList.length, pageSize, viewCustomerNameListOnClick])

  return (
    <PageContainer className="productListingPageContainer">
      <Header className="productListingHeader">
        <Image
          src="/chgd-logo-white.png"
          style={{ maxWidth: 300 }}
          preview={false}
        ></Image>
      </Header>
      <GridContent>
        <FloatButton.Group
          trigger="click"
          type="primary"
          icon={<WhatsAppOutlined />}
        >
          {contacts.map((c, index) => (
            <FloatButton
              key={index}
              style={{ width: 55, height: 55 }}
              description={`${c.ws_name}`}
              onClick={() =>
                window.open(`https://wa.me/${c.phone}`, "_blank")
              }
            />
          ))}
        </FloatButton.Group>
        {/* {eventValid ? ( */}
        <>
          {isContentLoaded && liveData ? (
            <>
              <div className="productListingContainer">
                <List
                  itemLayout="horizontal"
                  dataSource={contacts}
                  // style={{ width: 250 }}
                  renderItem={(item) => {
                    const url = `https://wa.me/${item.phone}`;

                    return (
                      <List.Item
                        style={{ padding: "3px 0", border: 0, textAlign: "center", display: "flex", justifyContent: "center" }}
                      >
                        <span style={{ fontWeight: "bold", cursor: "pointer", fontSize: "14px" }}
                          onClick={() => window.open(url, "_blank")}
                        >
                          {item.name}
                        </span>
                        {/* <List.Item.Meta
                          // avatar={<Avatar icon={<UserOutlined />} />}
                          title={item.name}
                        // description={`Chat via WhatsApp`}
                        /> */}
                      </List.Item>
                    );
                  }}
                />
                <div className="tableTitle specialFontFamily">
                  <h2>{liveData?.name}</h2>
                  <p>
                    {liveData?.startDate} - {liveData?.endDate}
                  </p>
                </div>
                <div className="specialFontFamily" style={{ marginBlockEnd: 15 }}>
                  {dataList.length} Products
                </div>
                {productDataCardList}
              </div>
            </>
          ) : (
            <>
              <div className="home-spinner-container">
                <Spin
                  indicator={
                    <LoadingOutlined spin style={{ fontSize: "2rem" }} />
                  }
                />
              </div>
            </>
          )}
        </>
        {/* ) : (
          <>
            {" "}
            <div className="productListingContainer">
              <Result
                style={{ marginInline: "auto" }}
                status="404"
                title="Event Unavailable"
              />
            </div>
          </>
        )} */}

        {/* <>{viewImgModal}</> */}
        {viewCustomerNameListModal}
      </GridContent>
      {/* NOTIFICATION */}
      {/* {contextHolder} */}
      <Footer className="productListingFooter">
        <span className="specialFontFamily">
          Chiang Heng Gold & Diamond Sdn Bhd (973341-U). All Rights Reserved.
        </span>
      </Footer>
    </PageContainer>
  );
};
export default FBLiveProductListingPage;
